/**
 * @desc 导出物流追踪to单
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.tms.transportMaster.exportTrackToReport.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/transportMaster/exportTrackToReport`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
